module.exports = __webpack_public_path__ + "img/king-george.8bf85226.png";